import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import NavigationBar from './components/NavigationBar';
import HomePage from './pages/HomePage';
import WebDesignPage from './pages/WebDesignPage';
import MobileAppPage from './pages/MobileAppPage';
import AIMLPage from './pages/AIMLPage';
import AutomationPage from './pages/AutomationPage';
import LeadGenPage from './pages/LeadGenPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ConsultationForm from './components/ConsultationForm';
import ChatBot from './components/ChatBot';
import { usePreventScrollFreeze } from './utils/scrolling';
import { useEffect } from 'react';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  usePreventScrollFreeze();

  return (
    <Router>
      <ScrollToTop />
      <NavigationBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/web-design" element={<WebDesignPage />} />
        <Route path="/mobile-apps" element={<MobileAppPage />} />
        <Route path="/ai-agents" element={<AIMLPage />} />
        <Route path="/automation" element={<AutomationPage />} />
        <Route path="/lead-generation" element={<LeadGenPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
      </Routes>
      <ConsultationForm />
      <ChatBot />
    </Router>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}